import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};
export const EyeIcon = ({size, onClick, isOpen}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			{isOpen ? (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M3.84618 10.578C3.38337 11.197 3.2 11.6933 3.2 12C3.2 12.3067 3.38337 12.8029 3.84618 13.422C4.29469 14.0219 4.95485 14.6683 5.77707 15.2641C7.42532 16.4585 9.65482 17.4 12 17.4C14.343 17.4 16.572 16.4459 18.2216 15.2438C19.0444 14.6442 19.7053 13.9955 20.1545 13.3971C20.6194 12.7778 20.8 12.2897 20.8 12C20.8 11.7103 20.6194 11.2222 20.1545 10.6029C19.7053 10.0045 19.0444 9.35576 18.2216 8.75619C16.572 7.55405 14.343 6.59999 12 6.59999C9.65482 6.59999 7.42532 7.54147 5.77707 8.73584C4.95485 9.33166 4.29469 9.97809 3.84618 10.578ZM5.07294 7.76414C6.87471 6.45852 9.34521 5.39999 12 5.39999C14.657 5.39999 17.128 6.47433 18.9284 7.78639C19.8306 8.44392 20.5821 9.1737 21.1142 9.8825C21.6306 10.5704 22 11.3181 22 12C22 12.6819 21.6306 13.4296 21.1142 14.1175C20.5821 14.8263 19.8306 15.5561 18.9284 16.2136C17.128 17.5257 14.657 18.6 12 18.6C9.34521 18.6 6.87471 17.5415 5.07294 16.2358C4.17016 15.5817 3.41782 14.8531 2.88508 14.1405C2.36663 13.4471 2 12.6933 2 12C2 11.3067 2.36663 10.5529 2.88508 9.85948C3.41782 9.1469 4.17016 8.41833 5.07294 7.76414Z"
						fill="#4C4C58"
					/>
					<path
						d="M12 9.59999C10.6745 9.59999 9.59999 10.6745 9.59999 12C9.59999 13.3255 10.6745 14.4 12 14.4C13.3255 14.4 14.4 13.3255 14.4 12C14.4 10.6745 13.3255 9.59999 12 9.59999ZM8.39999 12C8.39999 10.0118 10.0118 8.39999 12 8.39999C13.9882 8.39999 15.6 10.0118 15.6 12C15.6 13.9882 13.9882 15.6 12 15.6C10.0118 15.6 8.39999 13.9882 8.39999 12Z"
						fill="#4C4C58"
					/>
				</svg>
			) : (
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M20.1538 10.578C20.6166 11.197 20.8 11.6933 20.8 12C20.8 12.3 20.6244 12.7831 20.1795 13.3874C19.7481 13.9733 19.1121 14.6064 18.3176 15.1948C18.0513 15.392 17.9953 15.7678 18.1925 16.0341C18.3897 16.3004 18.7655 16.3564 19.0317 16.1592C19.9048 15.5126 20.6315 14.7974 21.1459 14.0988C21.6467 13.4185 22 12.6806 22 12C22 11.3067 21.6334 10.5529 21.1149 9.85948C20.5822 9.1469 19.8298 8.41833 18.9271 7.76414C17.1253 6.45852 14.6548 5.39999 12 5.39999C11.0354 5.39999 10.0962 5.54175 9.20668 5.78379C8.88694 5.87079 8.69826 6.20053 8.78526 6.52027C8.87226 6.84002 9.202 7.0287 9.52174 6.94169C10.3199 6.72453 11.1529 6.59999 12 6.59999C14.3452 6.59999 16.5747 7.54147 18.2229 8.73584C19.0452 9.33166 19.7053 9.97809 20.1538 10.578ZM5.8187 7.97827C5.62113 7.71225 5.2453 7.65676 4.97927 7.85434C4.10325 8.50497 3.37437 9.22268 2.85851 9.91907C2.35764 10.5952 2.00001 11.3291 2.00001 12C2.00001 12.6819 2.36944 13.4296 2.88579 14.1175C3.41786 14.8263 4.16936 15.5561 5.07164 16.2136C6.87205 17.5257 9.34302 18.6 12 18.6C12.966 18.6 13.9066 18.4597 14.7977 18.2196C15.1177 18.1334 15.3071 17.8041 15.2209 17.4842C15.1347 17.1642 14.8054 16.9747 14.4855 17.0609C13.6854 17.2765 12.8498 17.4 12 17.4C9.657 17.4 7.42796 16.4459 5.77838 15.2438C4.95565 14.6442 4.29466 13.9955 3.84548 13.3971C3.38058 12.7778 3.20001 12.2897 3.20001 12C3.20001 11.7159 3.37372 11.2396 3.82277 10.6334C4.25683 10.0474 4.89647 9.41061 5.69477 8.8177C5.9608 8.62012 6.01628 8.2443 5.8187 7.97827Z"
						fill="#4C4C58"
					/>
					<path
						d="M12 9.59998C13.3255 9.59998 14.4 10.6745 14.4 12C14.4 12.3314 14.6687 12.6 15 12.6C15.3314 12.6 15.6 12.3314 15.6 12C15.6 10.0118 13.9882 8.39998 12 8.39998C11.6687 8.39998 11.4 8.66861 11.4 8.99998C11.4 9.33135 11.6687 9.59998 12 9.59998ZM9.00003 11.4C8.66865 11.4 8.40003 11.6686 8.40003 12C8.40003 13.9882 10.0118 15.6 12 15.6C12.3314 15.6 12.6 15.3314 12.6 15C12.6 14.6686 12.3314 14.4 12 14.4C10.6745 14.4 9.60003 13.3255 9.60003 12C9.60003 11.6686 9.3314 11.4 9.00003 11.4Z"
						fill="#4C4C58"
					/>
					<path
						d="M3.87575 3.87572C3.64143 4.11003 3.64143 4.48993 3.87575 4.72425L19.2757 20.1243C19.5101 20.3586 19.89 20.3586 20.1243 20.1243C20.3586 19.8899 20.3586 19.51 20.1243 19.2757L4.72427 3.87572C4.48996 3.6414 4.11006 3.6414 3.87575 3.87572Z"
						fill="#4C4C58"
					/>
				</svg>
			)}
		</StyledSpan>
	);
};
EyeIcon.SIZE = SIZE;
EyeIcon.propTypes = {
	onClick: PropTypes.func,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
	isOpen: PropTypes.bool,
};

const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
